import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashIcon, UploadDocumentIcon } from "../../icons";

const UploadCertificate = ({ option, file, onUpload, onRemove }) => {
  return (
    <>
      {file && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mt: 1,
            p: 1,
            border: "1px solid #E6E7E8",
            borderRadius: 2,
            backgroundColor: "#fff",
            maxWidth: 320,
          }}
        >
          <UploadDocumentIcon color="action" />
          <Box sx={{ flexGrow: 1 }}>
            <Typography fontSize="14px" fontWeight={500}>
              {file.name}
            </Typography>
            <Typography fontSize="12px" color="text.secondary">
              {(file.size / 1024).toFixed(1)} KB
            </Typography>
          </Box>
          <TrashIcon
            color="error"
            sx={{ cursor: "pointer" }}
            onClick={() => onRemove(option)}
            titleAccess="Remove uploaded file"
          />
        </Box>
      )}
      <Button
        startIcon={<CloudUploadIcon />}
        component="label"
        sx={{
          textTransform: "none",
          fontSize: 13,
          height: 38,
          mt: 1,
          background: "#F0F6FE",
          color: "#1075FF",
          borderRadius: "6px",
          padding: "5px 25px",
        }}
      >
        {file ? "Re-upload Certificate (PDF/PNG)" : "Upload Certificate (PDF/PNG)"}
        <input
          type="file"
          hidden
          accept=".pdf,.png"
          onChange={(e) => onUpload(e, option)}
        />
      </Button>
    </>
  );
};

export default UploadCertificate;
